export default "__VITE_ASSET__CuOOUV17__"